export interface DisplayedProgramTemplate {
  id: string;
  name: string;
  type: string;
  latestVersion?: {
    version: number;
    status: string;
    id: string;
    applyClientTheme: boolean;
    emptyContent?: boolean;
  } | null;
}

export interface AllSelectedData {
  isAllSelected: boolean;
  page: number;
  selectedTouchpoints: DisplayedProgramTemplate[];
}

export const handleIsAllSelected = (
  allSelectedData: AllSelectedData[],
  pageIndex: number,
  displayedTemplates: DisplayedProgramTemplate[],
) => {
  const newAllSelectedData = [...allSelectedData];

  if (!newAllSelectedData[pageIndex]) {
    newAllSelectedData[pageIndex] = {
      isAllSelected: false,
      page: pageIndex,
      selectedTouchpoints: [],
    };
  }

  const current = newAllSelectedData[pageIndex];

  const isFullySelected =
    current.isAllSelected ||
    (!!displayedTemplates.length &&
      current.selectedTouchpoints.length === displayedTemplates.length &&
      displayedTemplates.every((tp) =>
        current.selectedTouchpoints.find((selectedTp) => selectedTp.id === tp.id),
      ));

  if (isFullySelected) {
    current.selectedTouchpoints = [];
    current.isAllSelected = false;
  } else {
    current.selectedTouchpoints = displayedTemplates.map((tp) => ({
      id: tp.id,
      name: tp.name,
      type: tp.type,
      latestVersion: tp.latestVersion ?? null,
    }));
    current.isAllSelected = true;
  }

  return newAllSelectedData;
};

export const handleIsSelected = ({
  allSelectedData,
  pageIndex,
  displayedTemplates,
  selectedTemplate,
}: {
  allSelectedData: AllSelectedData[];
  pageIndex: number;
  displayedTemplates: DisplayedProgramTemplate[];
  selectedTemplate: DisplayedProgramTemplate;
}) => {
  const existing = allSelectedData[pageIndex] ?? {
    isAllSelected: false,
    page: pageIndex,
    selectedTouchpoints: [],
  };

  let newSelectedTouchpoints: DisplayedProgramTemplate[];
  let newIsAllSelected: boolean;

  if (existing.isAllSelected && !existing.selectedTouchpoints.length) {
    newSelectedTouchpoints = displayedTemplates.filter((tp) => tp.id !== selectedTemplate.id);
    newIsAllSelected = false;
  } else {
    const alreadySelected = existing.selectedTouchpoints.some(
      (tp) => tp.id === selectedTemplate.id,
    );

    newSelectedTouchpoints = alreadySelected
      ? existing.selectedTouchpoints.filter((tp) => tp.id !== selectedTemplate.id)
      : [...existing.selectedTouchpoints, selectedTemplate];

    newIsAllSelected =
      newSelectedTouchpoints.length === displayedTemplates.length &&
      displayedTemplates.every((tp) => newSelectedTouchpoints.some((sel) => sel.id === tp.id));
  }

  const newPageEntry: AllSelectedData = {
    isAllSelected: newIsAllSelected,
    page: pageIndex,
    selectedTouchpoints: newSelectedTouchpoints,
  };

  const result = [...allSelectedData];
  result[pageIndex] = newPageEntry;
  return result;
};
